module.exports = __webpack_public_path__ + "img/1552761068.c29c5ca0.jpg";